import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styles from "./index.module.scss";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

export default function BackButton({ backSrc, ...props }) {
  const history = useHistory();
  const location = useLocation();

  const handleBack = () => {
    if (backSrc) {
      history.push(backSrc);
    } else if (location.state && location.state.path) {
      history.push({
        pathname: location.state.path,
        state: {
          searchKey: location.state.searchKey,
          teamData: location.state.teamData,
        },
      });
    } else {
      history.goBack();
    }
  };

  return (
    <div className={styles.container} {...props}>
      <div className={styles.backButton} onClick={handleBack}>
        <KeyboardArrowLeftIcon className={styles.icon} fontSize="inherit" />
        <span className={styles.text}>{props.text}</span>
      </div>
    </div>
  );
}
